import React from 'react';

interface DemoPageProps {
  t: (key: string) => any;
}

const DemoPage: React.FC<DemoPageProps> = ({ t }) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800">
      <h1 className="text-4xl font-bold mb-6 text-indigo-800 dark:text-white">{t('demo.title')}</h1>
      <p className="text-lg text-gray-700 dark:text-gray-300 mb-8 max-w-xl text-center">
        {t('demo.description')}
      </p>
      <form
        className="bg-white dark:bg-gray-900 p-8 rounded-lg shadow-lg w-full max-w-md flex flex-col gap-6"
        method="POST"
        action="mailto:demo@acentrical.com"
      >
        <label className="flex flex-col gap-2">
          <span className="font-medium text-gray-700 dark:text-gray-200">{t('demo.name')}</span>
          <input
            type="text"
            name="name"
            required
            className="border border-gray-300 dark:border-gray-700 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:bg-gray-800 dark:text-white"
            placeholder={t('demo.namePlaceholder')}
          />
        </label>
        <label className="flex flex-col gap-2">
          <span className="font-medium text-gray-700 dark:text-gray-200">{t('demo.email')}</span>
          <input
            type="email"
            name="email"
            required
            className="border border-gray-300 dark:border-gray-700 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:bg-gray-800 dark:text-white"
            placeholder={t('demo.emailPlaceholder')}
          />
        </label>
        <label className="flex flex-col gap-2">
          <span className="font-medium text-gray-700 dark:text-gray-200">{t('demo.phone')}</span>
          <input
            type="tel"
            name="phone"
            className="border border-gray-300 dark:border-gray-700 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:bg-gray-800 dark:text-white"
            placeholder={t('demo.phonePlaceholder')}
          />
        </label>
        <label className="flex flex-col gap-2">
          <span className="font-medium text-gray-700 dark:text-gray-200">{t('demo.message')}</span>
          <textarea
            name="message"
            rows={3}
            className="border border-gray-300 dark:border-gray-700 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:bg-gray-800 dark:text-white"
            placeholder={t('demo.messagePlaceholder')}
          />
        </label>
        <button
          type="submit"
          className="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white px-8 py-4 rounded-lg font-medium text-lg transition-all duration-300 shadow-lg"
        >
          {t('demo.cta')}
        </button>
      </form>
    </div>
  );
};

export default DemoPage;
